import axios from "axios";

export const client = (args: { token: string }) => {
  const { token } = args;
  const client = axios.create({ baseURL: process.env.REACT_APP_API_HOST });
  client.defaults.headers.common["Authorization"] = token;
  client.defaults.headers.common["Content-Type"] = "application/json";
  return client;
};
